import { cn } from '@lair-finance/util'
import { Link } from 'react-router-dom'

export function MenuLink({ className, children, to, active }: { className?: string; children: React.ReactNode; to: string; active?: boolean }) {
  return (
    <Link
      className={cn('inline-flex px-3 p-y-2 typo-label-2 text-greyscale-300 hover:text-greyscale-50', { 'text-greyscale-50': active }, className)}
      to={to}
    >
      {children}
    </Link>
  )
}
